import { useFormikContext } from 'formik'
import React from 'react'

export default function HomeSubmit({text, theme}) {
    const {handleSubmit} = useFormikContext()
  return (
    

    //HOMELAYOUT2
   <>
   {
     theme?
     <button onClick={handleSubmit} type='submit' 
       className={`py-4 m-1 md:py-3 px-4 text-lg text-slate-100 bg-theme hover:bg-theme rounded-md border-none md:rounded-xl w-full  md:text-white md:border md:border-white active:scale-[.97] transition-all ease-in-out duration-150 hover:border-transparent `}>
       {text}
     </button>
     :
     <button onClick={handleSubmit} type='submit' 
       className={`py-4 m-1 md:py-3 px-4 text-lg text-slate-100 bg-gray-500 hover:bg-slate-600 rounded-md border-none md:rounded-xl w-full  md:text-white md:border md:border-white active:scale-[.97] transition-all ease-in-out duration-150 hover:border-transparent `}>
       {text}
     </button>
   }
   </>
  )
}
